import {FormattedMessage} from "react-intl";
import React from 'react';

export const _t = (key, vars, defaultMsg)=>{
    return <FormattedMessage id={key}
                             values={vars}
                             defaultMessage={defaultMsg} />
};


export const formatRichText = {
    p: (chunks) => <p>{chunks}</p>,
    b: (chunks) => <b>{chunks}</b>,
    h3: (chunks) => <h3>{chunks}</h3>,
    h4: (chunks) => <h4>{chunks}</h4>,
    strong: (chunks) => <strong>{chunks}</strong>,
    ul: (chunks) => <ul>{chunks}</ul>,
    li: (chunks) => <li>{chunks}</li>,
    br: () => <br />
};